import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';
import * as actions from '../../redux/actions';

class SearchLegalAdviceQuestionsRequest extends baseRequest
{
    constructor() {
        super();
        this.name = 'SearchLegalAdviceQuestionsRequest';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        this.call(this.config.api.requests.searchLegalAdviceQuestions, payload);
    }

    onSuccess() {
        this.updateState();
    }

    updateState() {
        this.dispatch(actions.setLegalAdviceQuestionResults(this.response.data));
    }
}

export default SearchLegalAdviceQuestionsRequest;
